export default "__VITE_ASSET__BpOADjzF__"